import Typography from '@components/v2/ui/Typography/Typography';
import { Stack } from '@mui/material';
import { memo } from 'react';
import useWidth from '../../../components/Hooks/useWidth';
import { formatProductCodes } from '../utils/productCodes.utils';
import ProductDetailsContentHeaderButtons from './components/ProductDetailsContentHeaderButtons/ProductDetailsContentHeaderButtons';
import ProductDetailsHeaderTags from './components/ProductDetailsHeaderTags/ProductDetailsHeaderTags';
import { ProductDetailsContentHeaderProps } from './types/productDetailsContentHeader.interfaces';

const ProductDetailsContentHeader = ({
  name,
  code,
  referenceCode,
  tags,
  titleRef,
}: ProductDetailsContentHeaderProps) => {
  const { mobileWidth, mediumDownWidth } = useWidth();

  const codes = formatProductCodes({ code, referenceCode });

  return (
    <Stack gap={0.5} width="100%">
      <Stack direction="row" alignItems="center" gap={1.5} width="100%">
        <ProductDetailsHeaderTags tags={tags} />
        {!mediumDownWidth && <ProductDetailsContentHeaderButtons />}
      </Stack>

      <Stack ref={titleRef} gap={0.5} minWidth={0}>
        <Typography
          noWrap
          variant={mobileWidth ? 'h3' : 'h1'}
          sx={{ minWidth: 0, fontWeight: 'regular' }}
          color="textPrimary"
          title={name}
        >
          {name}
        </Typography>

        <Typography
          noWrap
          variant="micro1"
          color="text.secondary"
          sx={{ minWidth: 0 }}
          title={codes}
        >
          {codes}
        </Typography>
      </Stack>
    </Stack>
  );
};

export default memo(ProductDetailsContentHeader);
